import React, { PureComponent } from 'react';
import Components from '../components/components';
import Job from '../components/job/jobComponent';
import LinkBack from '../components/link-back';

class JobPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      jobSlug: null,
    };

    this.renderComponents = this.renderComponents.bind(this);
  }

  renderComponents() {
    const { modules } = this.props.data.page;

    return modules.map((module, key) => (
      <Components
        key={key}
        {...{
          content: {
            ...module,
          },
        }}
      />
    ));
  }

  componentDidMount() {
    const { search } = this.props.location;
    this.setState(() => ({
      jobSlug: search
        .split('=')
        .slice(-1)
        .pop(),
    }));
  }

  render() {
    const { jobSlug } = this.state;

    return (
      <div>
        <LinkBack
          {...{
            parent: {
              slug: 'careers',
              pageName: 'Careers',
            },
          }}
        />
        <div className="section indented-contents gray-dividers">
          <div className="mt-60" />
          {jobSlug && (
            <Job
              {...{
                jobSlug,
              }}
            />
          )}
        </div>
        <div className="section gray-dividers">
          {this.renderComponents()}
        </div>
      </div>
    );
  }
}

export default JobPage;

export const JobPageQuery = graphql`
    query JobPageQuery {
        page: datoCmsPageJob {
            modules {
                __typename
                ... on DatoCmsTraderProfile {
                    trader {
                        id
                        ...TraderFragment
                    }
                }
                # ... on DatoCmsVideo {
                #     video {
                #         ...VideoFragment
                #     }
                # }
                ... on DatoCmsFactBar {
                    facts {
                        title
                        body
                    }
                }
                ... on DatoCmsGreenLinkCollection {
                    links {
                        pageName
                        descriptionForLinks
                        iconForLinks {
                            sizes(maxWidth: 50) {
                                base64
                                aspectRatio
                                src
                                srcSet
                                sizes
                            }
                        }
                        slug
                        parentPage {
                            slug
                        }
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/templates/job-template.js